// Deploy-time configuration.
//
// LIVE_URLS: the console-live functions (functions/console-live/DEPLOY.md). Their default is the URL a
// 2nd-gen function gets in us-central1; VITE_CONSOLE_LIVE_*_URL overrides each at build time.
const env = (typeof import.meta !== "undefined" && import.meta.env) || {};
const BASE = "https://us-central1-syntaxeum-control-plane.cloudfunctions.net";

export const LIVE_URLS = Object.freeze({
  registry: env.VITE_CONSOLE_LIVE_REGISTRY_URL || `${BASE}/console-live-registry`,
  billing: env.VITE_CONSOLE_LIVE_BILLING_URL || `${BASE}/console-live-billing`,
  monitoring: env.VITE_CONSOLE_LIVE_MONITORING_URL || `${BASE}/console-live-monitoring`,
  vendors: env.VITE_CONSOLE_LIVE_VENDORS_URL || `${BASE}/console-live-vendors`,
  runners: env.VITE_CONSOLE_LIVE_RUNNERS_URL || `${BASE}/console-live-runners`,
});

// #607 D1: the registry callables (listSendableSignupsFn and the quote callables after it) live on
// syntaxeum-control-plane but verify `req.data.idToken` against syntaxeum-identity (commerce.js `identityAuth`).
// So the Quotes panel signs in a second time, against syntaxeum-identity, as a separate Firebase app instance
// (src/kit/identityAuth.js). This is the PUBLIC web config of that project (the same values browseandborrow ships in
// public/bootstrap.json "identity"): it identifies the project and authorises nothing; the server re-verifies every token.
export const REGISTRY_FUNCTIONS_BASE = env.VITE_REGISTRY_FUNCTIONS_BASE || BASE;

export const IDENTITY_FIREBASE_CONFIG = Object.freeze({
  apiKey: "AIzaSyAS9Zi0cgumuX0w5dpQwYysHc_AqyxCHw8",
  authDomain: "syntaxeum-identity.firebaseapp.com",
  projectId: "syntaxeum-identity",
  storageBucket: "syntaxeum-identity.firebasestorage.app",
  messagingSenderId: "955475073207",
  appId: "1:955475073207:web:157a6fb9fd8bf5fdd6d532",
});

// #607 iPad finding (a hypothesis until run on a real device): Firebase's signInWithPopup hands state between this origin
// and the cross-site auth domain through storage WebKit may partition, so on iOS/iPadOS the pop-up can end on "missing
// initial state". ONLY on iPadOS/iOS WebKit (src/kit/identityAuth.js isIosWebKit) the second sign-in gets its Google
// credential from Google Identity Services in THIS page and exchanges it with signInWithCredential. Every other browser
// keeps the Firebase pop-up regardless of this value. GIS needs the console origins under this OAuth client's
// "Authorized JavaScript origins"; if they are missing, the iPad shows a "Try the other sign-in" button that runs the
// Firebase pop-up. This is the identity project's OAuth WEB client (client_type 3 in browseandborrow's
// google-services.json). A client id is public and authorises nothing.
export const IDENTITY_GOOGLE_CLIENT_ID =
  env.VITE_IDENTITY_GOOGLE_CLIENT_ID || "955475073207-0063rm7t14ffhn49jnfoepeun6f0pm7n.apps.googleusercontent.com";
